import { SignatureDataCard } from "components/SignatureDataCard";
import { Container, StyledDiv } from "./TeltecData.styles";

export const TeltecData = ({ accessToken }: any) => {
  return (
    <Container>
      <StyledDiv>
        <SignatureDataCard accessToken={accessToken} />
      </StyledDiv>
    </Container>
  );
};
